import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["statusButton", "expandButton", "chevronButton", "dragHandle"]

  connect() {
    // Add click listener to the card
    this.boundHandleCardClick = this.handleCardClick.bind(this)
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)

    this.element.addEventListener('click', this.boundHandleCardClick)
    document.addEventListener('click', this.boundHandleClickOutside)

    // Store reference to this card when selected
    window.selectedActivityCard = null
  }

  disconnect() {
    // Clean up event listeners
    this.element.removeEventListener('click', this.boundHandleCardClick)
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  handleCardClick(event) {
    // Don't handle if clicking any button or interactive element
    const isStatusButton = event.target.closest('[data-present-mode-target="statusButton"]')
    const isExpandButton = event.target.closest('[data-present-mode-target="expandButton"]')
    const isChevronButton = event.target.closest('[data-present-mode-target="chevronButton"]')

    if (isStatusButton || isExpandButton || isChevronButton) {
      return
    }

    // Stop propagation to prevent document click handler
    event.stopPropagation()

    // Remove active border from all other cards
    this.removeOtherActiveBorders()

    // Add border to this card
    this.addActiveBorder()

    // Store reference to selected card
    window.selectedActivityCard = this.element
  }

  handleClickOutside(event) {
    // If click is outside this card, remove active border
    if (!this.element.contains(event.target)) {
      this.removeActiveBorder()

      // Clear selected card if this was the selected one
      if (window.selectedActivityCard === this.element) {
        window.selectedActivityCard = null
      }
    }
  }

  removeOtherActiveBorders() {
    // Find all activity cards and remove their active borders
    const allCards = document.querySelectorAll('[data-activity-card]')
    allCards.forEach(card => {
      if (card !== this.element) {
        card.classList.remove("border-[#5A36E6]", "border-2")
        card.classList.add("border-[#F2F3F5]")
      }
    })
  }

  addActiveBorder() {
    // Add brand border to activity card
    this.element.classList.remove("border-[#F2F3F5]")
    this.element.classList.add("border-[#5A36E6]", "border-2")
  }

  removeActiveBorder() {
    // Remove brand border from activity card
    this.element.classList.remove("border-[#5A36E6]", "border-2")
    this.element.classList.add("border-[#F2F3F5]")
  }

  enterPresentMode() {
    // Add brand border to activity card
    this.element.classList.remove("border-[#F2F3F5]")
    this.element.classList.add("border-[#5A36E6]", "border-2")

    // Hide edit mode buttons
    if (this.hasStatusButtonTarget) {
      this.statusButtonTarget.classList.add("hidden")
    }
    if (this.hasExpandButtonTarget) {
      this.expandButtonTarget.classList.add("hidden")
    }
    if (this.hasChevronButtonTarget) {
      this.chevronButtonTarget.classList.add("hidden")
    }
    if (this.hasDragHandleTarget) {
      this.dragHandleTarget.classList.add("opacity-0", "pointer-events-none")
    }

    // Toggle present/exit button visibility
    if (this.hasPresentButtonTarget) {
      this.presentButtonTarget.classList.add("hidden")
    }
    if (this.hasExitButtonTarget) {
      this.exitButtonTarget.classList.remove("hidden")
    }

    // Dispatch event for other controllers if needed
    this.dispatch("entered", { bubbles: true })
  }

  exitPresentMode() {
    // Remove brand border from activity card
    this.element.classList.remove("border-[#5A36E6]", "border-2")
    this.element.classList.add("border-[#F2F3F5]")

    // Show edit mode buttons
    if (this.hasStatusButtonTarget) {
      this.statusButtonTarget.classList.remove("hidden")
    }
    if (this.hasExpandButtonTarget) {
      this.expandButtonTarget.classList.remove("hidden")
    }
    if (this.hasChevronButtonTarget) {
      this.chevronButtonTarget.classList.remove("hidden")
    }
    if (this.hasDragHandleTarget) {
      this.dragHandleTarget.classList.remove("opacity-0", "pointer-events-none")
    }

    // Toggle present/exit button visibility
    if (this.hasPresentButtonTarget) {
      this.presentButtonTarget.classList.remove("hidden")
    }
    if (this.hasExitButtonTarget) {
      this.exitButtonTarget.classList.add("hidden")
    }

    // Dispatch event for other controllers if needed
    this.dispatch("exited", { bubbles: true })
  }
}
